export enum ThreadType {
  Filing,
  Amendment,
  Segment,
}
